export type SiteNavItem = {
  label: string;
  id: string;
  href: string;
};

export const MAIN_NAV_ITEMS: SiteNavItem[] = [
  { label: "ABOUT", id: "about", href: "/about" },
  { label: "SERVICES", id: "services", href: "/services" },
  { label: "PROJECTS", id: "projects", href: "/ux-portfolio" },
];
